import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import uuid from 'react-uuid';
import TapIcon from '../../../services/TapIcon';
import ValidationService from '../../../services/ValidationService';
import { toast } from 'react-toastify';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { useSelector } from 'react-redux';

function EditPan({viewVendorDetail}, ref) {

    const modalId                   =   uuid();
    const modalElementRef           =   useRef();
    const modalRef                  =   useRef();

    const access_token              =   useSelector(state => state.auth.access_token);

    const [formSubmitting, setFormSubmitting]   =   useState(false);
    const [id, setId]               =   useState('');
    const [oldPan, setOldPan]       =   useState('');
    const [pan, setPan]             =   useState('');

    useImperativeHandle(ref, () => ({
        initModalHandler: (id, pan) => {    
            setId(id);
            setOldPan(pan);
            setPan(pan);
            openModal()
        }
    }));

    useEffect(() => {
        modalElementRef.current             =   document.getElementById(modalId);
        modalRef.current                    =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);
        
    const openModal                 =   () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        setPan('');
        setOldPan('');
        setId('');
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }

    const submitForm        =   (e)  => {
        e.preventDefault();

        let error       =   ValidationService.rulesFirstErrorGenerator({pan},{pan : 'pan'});

        if(oldPan === pan) {
            error       =   "Old pan & new pan both are same."
        }
        if(error) {
            toast.error(error, {position: toast.POSITION.TOP_RIGHT});
            return;
        } 
        setFormSubmitting(pre => !pre);

        HttpAPICall.withAthorization('PUT', INVENTORY_API_BASE_URL_2 + '/vendor_pan_edit', access_token, { id, pan }, {}, (res) => {
            toast.success(res.data.msg, { position: toast.POSITION.TOP_RIGHT });
            closeModal();
            viewVendorDetail(id);
        }).then(() => setFormSubmitting(pre => !pre));
        
    }


  return (
    <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Edit Pan</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={formSubmitting} onClick={closeModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={submitForm} id={modalId+"Form"} method="post">
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label className="form-label require">Pan</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    name="pan"
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => {
                                        setPan(e.target.value)
                                    }}
                                    value={pan}
                                    autoComplete="off"
                                    required={true}
                                    placeholder='Please Enter Pan'
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" disabled={formSubmitting} data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                    <button type="submit" form={modalId+"Form"} disabled={formSubmitting} className="btn btn-primary">Save {formSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default forwardRef(EditPan)